import React, { useEffect, useState } from "react";
import "./Feedback.css";
import CityAutocomplete from "../ContactForm/CityAutocomplete";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";

import toast from "react-hot-toast";

export default function Feedback() {
  const API_BASE_URL = "https://prodapi.iworkkz.com:9095";
  const API_KEY = "X4gfacRza++DrL%2FqFYkhZJAuiuuJEsGwmfJz7tZHGi4%3D";

  const [category, setCategory] = useState("");
  const [robotList, setRobotList] = useState([]);
  const [selectedRobot, setSelectedRobot] = useState("");
  const [loading, setLoading] = useState(false);
  const [useSameDetails, setUseSameDetails] = useState(false);
  const [showThankYou, setShowThankYou] = useState(false);

  const [questionList, setQuestionList] = useState([]);
  const [questionLoading, setQuestionLoading] = useState(false);
  const [customer, setCustomer] = useState({
    name: "",
    connectname: "",
    phone: "",
    email: "",
    address: "",
    feedby: "",
    phonefby: "",
    remark: "",
  });

  const [city, setCity] = useState("");
  const [resetKey, setResetKey] = useState(0);

  // ✅ Store user answers
  const [answers, setAnswers] = useState({});

  // ✅ 1️⃣ LOAD ROBOTS WHEN CATEGORY CHANGES
  useEffect(() => {
    if (!category) return;

    const url = `${API_BASE_URL}/API/Robots/catactive?key=${API_KEY}&Category=${category}`;

    setLoading(true);
    setSelectedRobot("");
    setRobotList([]);
    setQuestionList([]);
    setAnswers({});

    fetch(url)
      .then((res) => res.json())
      .then((data) => {
        setRobotList(data);
        setLoading(false);
      })
      .catch(() => setLoading(false));
  }, [category]);

  // ✅ 2️⃣ LOAD QUESTIONS WHEN ROBOT CHANGES
  useEffect(() => {
    if (!selectedRobot) return;

    const questionUrl = `${API_BASE_URL}/API/template/actquestions?key=${API_KEY}&RobotId=${selectedRobot}`;

    setQuestionLoading(true);
    setQuestionList([]);
    setAnswers({});

    fetch(questionUrl)
      .then((res) => res.json())
      .then((data) => {
        setQuestionList(data.questions || []); // ✅ YOUR RESPONSE STRUCTURE
        setQuestionLoading(false);
      })
      .catch(() => setQuestionLoading(false));
  }, [selectedRobot]);

  // ✅ HANDLE ANSWER CHANGE
  const handleAnswerChange = (questionId, value) => {
    setAnswers((prev) => ({
      ...prev,
      [questionId]: value,
    }));
  };

  const handleSameDetails = () => {
    const newValue = !useSameDetails;
    setUseSameDetails(newValue);

    if (newValue) {
      // Copy upper details
      setCustomer((prev) => ({
        ...prev,
        feedby: prev.name,
        phonefby: prev.phone,
      }));
    } else {
      // Clear
      setCustomer((prev) => ({
        ...prev,
        feedby: "",
        phonefby: "",
      }));
    }
  };

  const handleSubmitFeedback = () => {
    // VALIDATION
    if (
      !customer.name ||
      !customer.connectname ||
      !customer.phone ||
      !customer.email ||
      !customer.address ||
      !city
    ) {
      alert("Please fill all customer details");
      return;
    }

    if (!category || !selectedRobot) {
      alert("Please select Category and Robot");
      return;
    }

    if (questionList.length === 0) {
      alert("No questions available");
      return;
    }

    const feedbackData = {
      Name: customer.name,
      ConnectName: customer.connectname,
      Phone: customer.phone,
      Email: customer.email,
      Address: customer.address,
      City: city,
      Category: category,
      RobotId: selectedRobot,
      Remark: customer.remark,
      FeedbackBy: customer.feedby,
      FeedbackbyPhone: customer.phonefby,
      Feedback: questionList.map((q) => ({
        QuestionId: q.QUESTIONID,
        QuestionText: q.QUESTION_TEXT,
        Answer: answers[q.QUESTIONID] || null,
      })),
    };

    console.log("Submitting Feedback:", feedbackData);

    fetch(`${API_BASE_URL}/API/feedback/create?key=${API_KEY}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "x-api-key": API_KEY,
      },
      body: JSON.stringify(feedbackData),
    })
      .then(async (res) => {
        const data = await res.json();

        if (!res.ok) {
          // ❌ FAILED → DO NOT CLEAR VALUES
          console.error("API Error:", data);
          alert("Feedback submission failed");
          return;
        }

        // ✅ SUCCESS → NOW CLEAR VALUES
        setCustomer({
          name: "",
          connectname: "",
          phone: "",
          email: "",
          address: "",
          feedby: "",
          phonefby: "",
          remark: "",
        });

        setCity("");
        setResetKey((prev) => prev + 1);
        setAnswers({});
        setQuestionList([]);
        setSelectedRobot("");
        setCategory("");
        setUseSameDetails(false);

        // toast.success("Feedback submitted successfully");
        setShowThankYou(true);
        setTimeout(() => setShowThankYou(false), 4000);
      })
      .catch((err) => {
        console.error("Submit Error:", err);
        toast.error("Failed to submit feedback");
      });
  };

  // ✅ STAR RENDER FUNCTION
  const renderStars = (questionId) => {
    const selectedValue = answers[questionId] || 0;

    return (
      <div className="star-box">
        {[1, 2, 3, 4, 5].map((star) => (
          <span
            key={star}
            className={star <= selectedValue ? "star active" : "star"}
            onClick={() => handleAnswerChange(questionId, star)}
          >
            ★
          </span>
        ))}
      </div>
    );
  };

  return (
    <div className="FeedbackContainer">
      <div className="Customerdetails">
        <div className="row">
          <div className="col-md-12 col-sm-12">
            <input
              name="name"
              type="text"
              placeholder="Company Name"
              required
              value={customer.connectname}
              onChange={(e) =>
                setCustomer({ ...customer, connectname: e.target.value })
              }
            />
          </div>
        </div>
        <div className="row">
          <div className="col-md-4 col-sm-12">
            <input
              name="name"
              type="text"
              placeholder="Company Connect Name"
              required
              value={customer.name}
              onChange={(e) =>
                setCustomer({ ...customer, name: e.target.value })
              }
            />
          </div>
          <div className="col-md-4 col-sm-12">
            <PhoneInput
              country="in"
              value={customer.phone}
              onChange={(value) =>
                setCustomer({ ...customer, phone: "+" + value })
              }
              enableSearch
              inputStyle={{ width: "100%" }}
            />
          </div>
          <div className="col-md-4 col-sm-12">
            <input
              name="email"
              type="email"
              placeholder="Your Email Id"
              required
              value={customer.email}
              onChange={(e) =>
                setCustomer({ ...customer, email: e.target.value })
              }
            />
          </div>
        </div>

        <div className="row">
          <div className="col-md-8 col-sm-12">
            <input
              name="address"
              type="text"
              placeholder="Your Address"
              required
              value={customer.address}
              onChange={(e) =>
                setCustomer({ ...customer, address: e.target.value })
              }
            />
          </div>
          <div className="col-md-4 col-sm-12">
            <div className="mb-3">
              <CityAutocomplete
                key={resetKey}
                name="city"
                value={city}
                onChange={(val) => setCity(val || "")}
                onSelect={(opt) => setCity(opt?.label || opt || "")}
              />
            </div>
          </div>
          <div className="col-md-4 col-sm-12"></div>
        </div>
      </div>
      {/* ✅ CATEGORY RADIO BUTTONS */}
      <div className="radio-group" style={{ marginTop: "20px" }}>
        {["Greeting", "Cleaning", "Delivery"].map((cat) => (
          <label key={cat}>
            <input
              type="radio"
              name="category"
              value={cat}
              checked={category === cat}
              onChange={(e) => setCategory(e.target.value)}
            />
            {cat}
          </label>
        ))}
      </div>

      {/* ✅ ROBOT SELECT */}
      <div style={{ marginTop: "15px" }}>
        <select
          value={selectedRobot}
          onChange={(e) => setSelectedRobot(e.target.value)}
          disabled={!category || loading}
        >
          <option value="">
            {loading ? "Loading robots..." : "Select Robot"}
          </option>

          {robotList.map((robot) => (
            <option key={robot.ID} value={robot.ID}>
              {robot.NAME}
            </option>
          ))}
        </select>
      </div>

      {/* ✅ QUESTIONS */}
      <div style={{ marginTop: "30px" }}>
        {questionLoading && <p>Loading questions...</p>}

        {!questionLoading && questionList.length > 0 && (
          <>
            <div className="question-box">
              <h4>Feedback Questions</h4>

              <table className="question-table">
                <thead>
                  <tr>
                    <th style={{ width: "60%" }}>Question</th>
                    <th style={{ width: "40%" }}>Feedback</th>
                  </tr>
                </thead>
                <tbody>
                  {questionList.map((q, index) => (
                    <tr key={q.QUESTIONID}>
                      {/* ✅ QUESTION COLUMN */}
                      <td>{q.QUESTION_TEXT}</td>

                      {/* ✅ FEEDBACK COLUMN */}
                      <td>
                        {/* ✅ RATING TYPE → 5 STARS */}
                        {q.QUESTION_TYPE === "Rating" &&
                          renderStars(q.QUESTIONID)}

                        {/* ✅ DROPDOWN TYPE → YES / NO */}
                        {q.QUESTION_TYPE === "Dropdown" && (
                          <div style={{ display: "flex", gap: "20px" }}>
                            <label>
                              <input
                                type="radio"
                                name={`question_${q.QUESTIONID}`}
                                value="Yes"
                                checked={answers[q.QUESTIONID] === "Yes"}
                                onChange={(e) =>
                                  handleAnswerChange(
                                    q.QUESTIONID,
                                    e.target.value
                                  )
                                }
                              />{" "}
                              Yes
                            </label>

                            <label>
                              <input
                                type="radio"
                                name={`question_${q.QUESTIONID}`}
                                value="No"
                                checked={answers[q.QUESTIONID] === "No"}
                                onChange={(e) =>
                                  handleAnswerChange(
                                    q.QUESTIONID,
                                    e.target.value
                                  )
                                }
                              />{" "}
                              No
                            </label>
                          </div>
                        )}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>

            <div style={{ fontSize: "13px", margin: "10px 0px" }}>
              <label
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: "6px",
                }}
              >
                <input
                  type="checkbox"
                  checked={useSameDetails}
                  onChange={handleSameDetails}
                />
                Same as Customer Details
              </label>
            </div>

            <div className="Customerdetails">
              <div className="row">
                <div className="col-md-4 col-sm-12">
                  <input
                    name="name"
                    type="text"
                    placeholder="Feedback By"
                    required
                    value={customer.feedby}
                    onChange={(e) =>
                      setCustomer({ ...customer, feedby: e.target.value })
                    }
                  />
                </div>

                <div className="col-md-4 col-sm-12">
                  <PhoneInput
                    country="in"
                    value={customer.phonefby}
                    onChange={(value) =>
                      setCustomer({ ...customer, phonefby: "+" + value })
                    }
                    enableSearch
                    inputStyle={{ width: "100%" }}
                  />
                </div>
              </div>
              <div className="row">
                <div className="col-md-12 col-sm-12">
                  <textarea
                    name="name"
                    type="text"
                    placeholder="Let us know your views.."
                    required
                    value={customer.remark}
                    onChange={(e) =>
                      setCustomer({ ...customer, remark: e.target.value })
                    }
                  />
                </div>
              </div>
            </div>

            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <button className="submit-btn" onClick={handleSubmitFeedback}>
                Submit Feedback
              </button>
            </div>
          </>
        )}

        {!questionLoading && selectedRobot && questionList.length === 0 && (
          <p>No questions found for this robot.</p>
        )}
      </div>

      {showThankYou && (
        <div className="thankyou-popup">
          <div className="thankyou-card">
            <h2 className="thankyou-title">
              🎉 Thank You for Your Feedback! 🎉
            </h2>

            {/* Floating sparkles */}
            <div className="sparkles">
              {[...Array(12)].map((_, i) => (
                <span key={i} className={`sparkle s-${i}`}>
                  ✦
                </span>
              ))}
            </div>

            {/* Confetti burst */}
            <div className="confetti">
              {[...Array(20)].map((_, i) => (
                <span key={i} className={`c c-${i}`}></span>
              ))}
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
